import { render, staticRenderFns } from "./DeleteCircleIcon.vue?vue&type=template&id=6dfd5784"
import script from "./DeleteCircleIcon.vue?vue&type=script&lang=js"
export * from "./DeleteCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports